type ClockIconProps = {
  className?: string;
};

/** Default picker size: h-5 (1.25rem) enlarged by 5%. */
export const CLOCK_ICON_SIZE_CLASS = 'h-[1.3125rem] w-[1.3125rem]';

/** Label size: h-4 (1rem) enlarged by 5%. */
export const CLOCK_ICON_SIZE_SM_CLASS = 'h-[1.05rem] w-[1.05rem]';

/** Shared filled clock artwork for time pickers across the app. */
export const ClockIcon = ({ className = `${CLOCK_ICON_SIZE_CLASS} shrink-0` }: ClockIconProps) => (
  <svg className={className} viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="30" cy="30" fill="#f1f3f4" r="22" />
    <path
      d="M30,53.5A23.5,23.5,0,1,1,53.5,30,23.527,23.527,0,0,1,30,53.5Zm0-44A20.5,20.5,0,1,0,50.5,30,20.523,20.523,0,0,0,30,9.5Z"
      fill="#f28080"
    />
    <path
      d="M8,31.5A1.5,1.5,0,0,1,6.5,30,23.527,23.527,0,0,1,30,6.5a1.5,1.5,0,0,1,0,3A20.523,20.523,0,0,0,9.5,30,1.5,1.5,0,0,1,8,31.5Z"
      fill="#f2bf80"
    />
    <path
      d="M30,31.5a1.5,1.5,0,0,1-1.061-.439l-6-6a1.5,1.5,0,0,1,2.122-2.122L30,27.879l8.939-8.94a1.5,1.5,0,0,1,2.122,2.122l-10,10A1.5,1.5,0,0,1,30,31.5Z"
      fill="#f28080"
    />
    <path
      d="M30,17.5A1.5,1.5,0,0,1,28.5,16V14a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,30,17.5Z"
      fill="#aaadbf"
    />
    <path
      d="M30,47.5A1.5,1.5,0,0,1,28.5,46V44a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,30,47.5Z"
      fill="#aaadbf"
    />
    <path d="M16,31.5H14a1.5,1.5,0,0,1,0-3h2a1.5,1.5,0,0,1,0,3Z" fill="#aaadbf" />
    <path d="M46,31.5H44a1.5,1.5,0,0,1,0-3h2a1.5,1.5,0,0,1,0,3Z" fill="#aaadbf" />
    <circle cx="30" cy="30" fill="#f2bf80" r="2" />
  </svg>
);
